// import { get_access_token, logout } from "../../utils/supabase-auth"
import { useRouter } from "next/router"
import { getTraitValue, resolveDropTier } from "../../utils/marketplace/helpers"
import { isTestnetOrderCurrency } from "../../utils/enum/constants"
import { ethers } from "ethers"
import useAuth from "./useAuth"
import { CONTRACT_ADDRESS } from "@/src/abis/constants"
import JsonAbi from "@/src/abis/HapeAccessory.json"
import { getContractMethods } from "@/src/marketplaceWeb3/web3"
import { rememberOriginalEquippedPayload } from "../../services/fashion-index/equippedDropsMapping"
import { buildOpenBoxPayload } from "@/src/components/OpenBox/openBoxPayload"

function useRequest() {
	const router = useRouter()
	const { get_access_token, logout, clear_tokens } = useAuth()
	async function get(
		api: string,
		params: Record<string, any> = {},
		signal?: AbortSignal,
	) {
		// console.log("useRequest get api", api)
		let url = process.env.NEXT_PUBLIC_API_BASE_URL + "/frontend/api/v1" + api
		if (params && Object.keys(params).length > 0) {
			const query = Object.keys(params)
				.map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
				.join("&")
			url = url + `?${query}`
		}
		const token = await get_access_token()
		// console.log("token", token)
		// if (!token) {
		//   logout();
		//   router.replace('/login');
		//   return {
		//       code: 401,
		//       message: "Unauthorized"
		//   }
		// }
		// console.log("useRequest get url", url)
		const header: Record<string, string> = {
			Authorization: `Bearer ${token}`,
		}
		const response = await fetch(url, {
			method: "GET",
			headers: header,
			signal,
			cache: "no-store",
		})
		// console.log("useRequest get response", response)
		return handleResponse(response)
	}

	async function app_get(api: string, params: Record<string, any> = {}) {
		// console.log("useRequest get api", api)
		let url = process.env.NEXT_PUBLIC_API_BASE_URL + api
		if (params && Object.keys(params).length > 0) {
			const query = Object.keys(params)
				.map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
				.join("&")
			url = url + `?${query}`
		}
		const token = await get_access_token()
		const header: Record<string, string> = {
			Authorization: `Bearer ${token}`,
		}
		const response = await fetch(url, {
			method: "GET",
			headers: header,
		})
		// console.log("useRequest get response", response)
		return handleResponse(response)
	}

	async function post(api: string, params: Record<string, any>) {
		let url = process.env.NEXT_PUBLIC_API_BASE_URL + "/frontend/api/v1" + api
		const token = await get_access_token()
		// if (!token) {
		//   logout();
		//   router.replace('/login');
		//   return {
		//       code: 401,
		//       message: "Unauthorized"
		//   }
		// }
		const header: Record<string, string> = {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		}
		const response = await fetch(url, {
			method: "POST",
			headers: header,
			body: JSON.stringify(params),
		})
		return handleResponse(response)
	}

	async function handleResponse(response: Response) {
		if (response.ok) {
			return response.json()
		} else if (response.status === 401 || response.status === 403) {
			clear_tokens()
			router.replace("/login")
			return response.json()
		} else {
			let data
			try {
				data = await response.json()
			} catch (e) {
				data = await response.text()
			}
			// console.log("handleResponse data", data)
			return data
			// throw new Error(typeof data === 'string' ? data : (data.message || '请求失败'));
		}
	}

	const registerVote = async (winner: number, loser: number) => {
		console.log("registerVote", winner, loser)
		const res = await post("/vote", {
			winner_token_id: winner,
			loser_token_id: loser,
		})
		if (res.code === 200) {
			console.log("registerVote res", res)
		}
	}

	const getOrders = async (userId, page, size): Promise<any> => {
		try {
			// console.log("getOrders", userId)
			const res = await get("/orders/list", {
				page: page,
				size: size,
			})
			if (res.code === 200) {
				res.results = res.data.orders
				for (let i = 0; i < res.results.length; i++) {
					let order = res.results[i]
					let minted_number = 0
					let need_mint_number = 0
					let airdrop_status = "AWAITING_PAYMENT"
					let flag = false
					let description: {
						description: string
						quantity: number
						is_airdrop: string
					}[] = []
					if (order.cart_goods) {
						for (let j = 0; j < order.cart_goods.length; j++) {
							let drop_good = order.cart_goods[j]
							if (drop_good.is_minted) {
								minted_number += 1
							}
							if (drop_good.good_type == 1) {
								need_mint_number += 1
							}
							let is_airdrop = "false"
							if (drop_good.is_minted && drop_good.good_type == 1) {
								is_airdrop = "true"
							}
							if (drop_good.good_type == 2) {
								is_airdrop = "true"
							}
							if (!drop_good.is_minted && drop_good.good_type == 1) {
								flag = true
								airdrop_status = "Minting..."
							}
							description.push({
								description:
									drop_good.drop?.name ||
									drop_good.good_name ||
									(order.is_free_claim
										? "Free claim — Blind Box"
										: "Item"),
								quantity: drop_good.quantity,
								is_airdrop: is_airdrop,
							} as any)
						}
					}
					if (!flag) {
						airdrop_status = "SUCCESS"
					}
					order.minted_number = minted_number
					order.need_mint_number = need_mint_number
					order.airdrop_status = airdrop_status
					order.description = description
				}
				if (process.env.USE_MAINNET === "true") {
					res.results = (res.results || []).filter(
						(order: { currency?: string }) =>
							!isTestnetOrderCurrency(order.currency),
					)
				}
				return res
			} else {
				console.log(res.message)
			}
			return {
				code: res.code,
				message: res.message,
				results: [],
			}
		} catch (err) {
			alert(err.message)
		}
	}

	const getProductList = async (
		page,
		isLive,
		params: Record<string, any> = {},
	) => {
		try {
			const res = await get("/drops/list", {
				page: page,
				size: 100,
				isLive: isLive,
				promotion_type: 0,
				...params,
			})
			if (res.code === 200) {
				res.results = res.data.drops
				let temp = []
				for (let i = 0; i < res.results.length; i++) {
					let drop = res.results[i]
					temp.push(drop.id)
					drop.tier_standard = resolveDropTier(drop)
					drop.primary_color = getTraitValue(drop.attributes, "Primary Colour")
					drop.secondary_color = getTraitValue(
						drop.attributes,
						"Secondary Color",
					)
				}
				if (temp.length > 0) {
					const res2 = await post("/drops/payment-methods/batch", {
						drop_ids: temp,
					})
					if (res2.code === 200) {
						for (let i = 0; i < res2.data.results.length; i++) {
							let payment_method = res2.data.results[i]
							for (let j = 0; j < res.results.length; j++) {
								let drop = res.results[j]
								if (drop.id === payment_method.drop_id) {
									drop.payment_method = payment_method
								}
							}
						}
					}
				}
				return res.results
			} else {
				console.log(res.message)
			}
			return []
		} catch (err) {
			console.error("getProductList error:", err)
			return []
		}
	}

	const getBoxList = async (params: Record<string, any> = {}) => {
		try {
			const res = await get("/drops/list", {
				page: 1,
				size: 1000,
				promotion_type: 1,
				...params,
			})
			if (res.code === 200) {
				res.results = res.data.drops
				let temp = []
				for (let i = 0; i < res.results.length; i++) {
					let drop = res.results[i]
					temp.push(drop.id)
					drop.promotion_type = 1
					drop.tier_standard = resolveDropTier(drop)
					drop.primary_color = getTraitValue(drop.attributes, "Primary Colour")
					drop.secondary_color = getTraitValue(
						drop.attributes,
						"Secondary Color",
					)
				}
				if (temp.length > 0) {
					const res2 = await post("/drops/payment-methods/batch", {
						drop_ids: temp,
					})
					if (res2.code === 200) {
						for (let i = 0; i < res2.data.results.length; i++) {
							let payment_method = res2.data.results[i]
							for (let j = 0; j < res.results.length; j++) {
								let drop = res.results[j]
								if (drop.id === payment_method.drop_id) {
									drop.payment_method = payment_method
								}
							}
						}
					}
				}
				return res.results
			}
			console.log(res.message)

			return []
		} catch (err) {
			console.error("getBoxList error:", err)
			return []
		}
	}

	const fetchBanner = async (bannerType: any) => {
		const response = await get(`/banners`, { banner_type: bannerType })
		return response
	}

	const getCategoriesForFilters = async (): Promise<any[]> => {
		try {
			const res = await get("/drop/types/tree", {})
			if (res.code === 200) {
				return res.data
			}
			return []
		} catch (error) {
			console.error("Error fetching categories:", error)
			throw error
		}
	}

	const getLiveCollections = async () => {
		try {
			const res = await get("/collections/list", {
				page: 1,
				size: 1000,
			})
			if (res.code === 200) {
				return res.data.collections
			} else {
				console.log(res.message)
				return []
			}
		} catch (err) {
			console.error("Error fetching live collections:", err)
			throw err
		}
	}

	const getColorsForFilters = async (): Promise<any[]> => {
		try {
			return [
				"multi-colour",
				"silver",
				"tiger style",
				"graphite",
				"orange",
				"black",
				"white",
			]
			// const response: AxiosResponse<{ colors: any[] }> = await dropsApi.get(
			//     "/products/colors"
			// )
			// return response.data.colors
		} catch (error) {
			console.error("Error fetching colors:", error)
			throw error
		}
	}

	const getWalletAddressList = async () => {
		const res = await get("/users/wallets/", {
			page: 1,
			size: 1000,
		})
		console.log("res---->", res)
		if (res.code === 200) {
			let wallets = res.data.wallets
			return wallets
		} else {
			return []
		}
	}

	const addCart = async (drops: { drop_id: string; quantity: number }[]) => {
		console.log("addCart---->", drops)
		if (!post) return
		const res = await post("/carts/add/to/cart", {
			drops: drops,
		})
		if (res.code === 200) {
			console.log("addCart---->", res)
		} else {
			console.log(res.message)
		}
		return res
	}

	const getCart = async () => {
		const res = await get("/carts/list", {})
		if (res.code === 200) {
			res.products = res.data.drop_goods
			// console.log('res.products---->', res.products)
			let totalUSD = 0
			let totalPoints = 0
			for (let i = 0; i < res.products.length; i++) {
				let cart_drop = res.products[i]
				cart_drop.tier_standard = resolveDropTier(cart_drop.drop)
				cart_drop.primary_color = getTraitValue(
					cart_drop.drop.attributes,
					"Primary Colour",
				)
				cart_drop.secondary_color = getTraitValue(
					cart_drop.drop.attributes,
					"Secondary Color",
				)
				totalUSD += cart_drop.drop.price * cart_drop.quantity
				totalPoints += cart_drop.drop.points_price * cart_drop.quantity
			}
			res.totalUSD = totalUSD
			res.totalPoints = totalPoints
			return res
			//   setTotal(res.data.total)
		} else {
			console.log(res.message)
			return {
				code: res.code,
				message: res.message,
				products: [],
			}
		}
	}

	const removeFromCart = async (
		drops: { drop_id: string; quantity: number }[],
	) => {
		const res = await post("/carts/remove/from/cart", {
			drops: drops,
		})
		if (res.code === 200) {
			return res
		}
		console.log(res.message)
		return res
	}

	const getProduct = async (productId) => {
		try {
			const res = await get("/drops", {
				id: productId,
			})
			if (res.code === 200) {
				let url = `/drops/${productId}/payment-methods`
				const res2 = await get(url)
				if (res2.code === 200) {
					res.payment_method = res2.data
				}
				return res
			} else {
				console.log(res.message)
			}
			return null
		} catch (err) {
			console.log(err)
		}
	}

	async function checkWallet(account: string) {
		let response = await get("/users/wallet/bind/status", {
			wallet_address: account,
		})
		if (response.code === 200 && response.data) {
			return true
		}
		return false
	}

	async function bindWallet(account: string, signer: ethers.Signer) {
		const message = account.toLowerCase()
		const signature = await signer.signMessage(message)
		let response = await post("/users/bind/wallet", {
			wallet_address: account,
			signature: signature,
		})
		return response
	}

	const getWalletList = async () => {
		const res = await get("/users/wallets/", {
			page: 1,
			size: 1000,
		})
		return res
	}

	const unbindWallet = async (wallet_address: string) => {
		const res = await post("/users/unbind/wallet", {
			wallet_address: wallet_address,
		})
		return res
	}

	const getInventoryList = async (page: number, size: number) => {
		const res = await get("/users/purchased/drops", {
			page: page,
			size: size,
		})
		if (res.code === 200) {
			for (let i = 0; i < res.data.drops.length; i++) {
				let drop = res.data.drops[i]
				drop.tier_standard = resolveDropTier(drop)
				drop.primary_color = getTraitValue(drop.attributes, "Primary Colour")
				drop.secondary_color = getTraitValue(drop.attributes, "Secondary Color")
			}
			return res
		} else {
			console.log(res.message)
		}
		return null
	}

	const livePriceFunc = async () => {
		let ether = 0,
			cmp = 0

		try {
			const response = await get("/price/exchange")
			// console.log("livePriceFunc response---->", response)
			if (response.code === 200) {
				return {
					ether: response?.data?.ether ?? ether,
					cmp: response?.data?.cmp ?? cmp,
				}
			} else {
				return { ether, cmp }
			}
		} catch (err) {
			console.log({ err })
			return { ether, cmp }
		}
	}

	const getSignature = async (
		user_address: string,
		token_ids: number[],
		amounts: number[],
		data: string,
	) => {
		const res = await post("/signatures/generate/batch-mint", {
			user_address: user_address,
			data: data,
			token_ids: token_ids,
			amounts: amounts,
		})
		return res
	}

	const updateOrder = async (
		order_id: string,
		status: number,
		hash: string,
		Currency: string,
	) => {
		let data = {
			id: order_id,
			status: status,
			currency: Currency,
		} as any
		if (hash && hash.length > 0) {
			data.hash = hash
		}
		console.log("data---->", data)
		const res = await post("/orders/update", data)
		return res
	}

	const getOpenBoxNonce = async (data: any) => {
		const res = await post("/drops/unbox/nonce", data)
		if (res.code === 200) {
			return res.data
		}
		return null
	}

	const openBox = async (data: any) => {
		const revealPayload = buildOpenBoxPayload(
			data.mystery_nft_id,
			data.drops,
			data.user_wallet_address || "",
		)
		let openNonce = data.open_nonce
		if (!openNonce) {
			const nonceRes = await getOpenBoxNonce(revealPayload)
			openNonce = nonceRes?.open_nonce
		}
		const res = await post("/drops/unbox", {
			...revealPayload,
			open_nonce: openNonce,
		})
		return res
	}

	const getBoxDrops = async (mystery_id: any) => {
		const res = await get("/drops/mystery/drops/list", {
			mystery_id: mystery_id,
		})
		if (res.code === 200) {
			return res.data.mystery_drops
		}
		return []
	}

	const getOpenenBoxs = async (data: any) => {
		const res = await post("/drops/opend/boxes", data)
		// console.log("getOpenenBoxs res", res)
		if (res.code === 200) {
			// console.log("getOpenenBoxs res.data.boxes", res.data?.boxes)
			return res.data?.boxes ?? []
		}
		return []
	}

	const getUserBoxes = async (_address: string = "") => {
		const res = await get("/users/mystery/list", {
			address: _address,
		})

		if (res.code === 200) {
			if (res.data && res.data.mysteries && res.data.mysteries.length > 0) {
				const opendBoxes = await getOpenenBoxs({
					address: _address,
					boxes: res.data.mysteries,
				})
				const token_ids = res.data.mysteries.map((box) => box.token_id)
				try {
					const contractM = await getContractMethods(
						JsonAbi.abi,
						CONTRACT_ADDRESS.BoxContract_address,
					)
					const addresses = token_ids.map(() => _address)
					const balances = await contractM.methods
						.balanceOfBatch(addresses, token_ids)
						.call()
					for (let i = 0; i < token_ids.length; i++) {
						const box = res.data.mysteries.find(
							(item) => item.token_id === token_ids[i],
						)
						if (box) {
							const onChainBalance =
								typeof balances[i] === "string"
									? parseInt(balances[i], 10)
									: balances[i]
							// Only raise the DB balance when chain is higher so
							// DB-only credits (no matching mint) are not wiped to 0.
							if (onChainBalance > box.balance) {
								box.balance = onChainBalance
							}
						}
					}
				} catch (err) {
					console.log("balanceOfBatch err :", err)
				}
				for (let i = 0; i < res.data.mysteries.length; i++) {
					const box = res.data.mysteries[i]
					const openedCount = opendBoxes.filter(
						(item) => item.mystery_nft_id === box.token_id,
					).length
					if (box && box.balance > 0 && openedCount > 0) {
						box.balance = Math.max(0, box.balance - openedCount)
					}
				}
			}
			return res.data?.mysteries ?? []
		}
		return []
	}

	const getSetBoxEligibility = async (): Promise<{
		success: boolean
		data?: Record<string, unknown>
		message?: string
		code?: number
	}> => {
		try {
			const res = await get("/users/mystery/eligibility")
			if (res?.code === 200 && res.data) {
				return { success: true, data: res.data }
			}
			return {
				success: false,
				message: res?.message || "Unable to check eligibility",
				code: res?.code,
			}
		} catch (err) {
			console.log("getSetBoxEligibility error:", err)
			return { success: false, message: "Unable to check eligibility" }
		}
	}

	const claimSetBoxReward = async (wallet_address: string, quantity?: number) => {
		const body: Record<string, any> = { wallet_address }
		if (quantity && quantity > 0) {
			body.quantity = quantity
		}
		return post("/users/mystery/eligibility/claim", body)
	}

	const getShareInfo = async (Id: string, platform: string) => {
		const res = await post(`/hapes/${Id}/share`, {
			platform: platform,
		})
		if (res.code === 200) {
			return res.data
		}
		return null
	}

	const getVoteInfo = async (Id: string) => {
		const res = await get(`/hapes/${Id}/vote/info`)
		if (res.code === 200) {
			return res.data
		}
		return null
	}

	const vote = async (params: any) => {
		const res = await post(`/hapes/vote`, params)
		if (res.code === 200) {
			return res.data
		}
		return null
	}

	const getEquippedTraits = async (Id: string, signal?: AbortSignal) => {
		const timeout = AbortSignal.timeout(15_000)
		let timed: AbortSignal = timeout
		if (signal) {
			const controller = new AbortController()
			const abort = () => controller.abort()
			if (signal.aborted || timeout.aborted) controller.abort()
			else {
				signal.addEventListener("abort", abort, { once: true })
				timeout.addEventListener("abort", abort, { once: true })
			}
			timed = controller.signal
		}
		const [res1, res2] = await Promise.all([
			get(`/hape/equipped/drops`, { hape_id: Id }, timed),
			get(`/hape/original/equipped/drops`, { hape_id: Id }, timed).catch(
				() => null,
			),
		])
		if (res2?.code === 200 && res2.data) {
			rememberOriginalEquippedPayload(Id, res2.data)
		}
		if (
			res1?.code === 200 &&
			res1.data &&
			res1.data.drops &&
			res1.data.drops.length > 0
		) {
			return res1.data.drops
		}

		if (
			res2?.code === 200 &&
			res2.data &&
			((res2.data.original_drops && res2.data.original_drops.length > 0) ||
				(res2.data.drops && res2.data.drops.length > 0))
		) {
			return res2.data.original_drops || res2.data.drops
		}

		// if (res2?.code === 200 && res2.data && res2.data.attributes && res2.data.attributes.length > 0) {
		//     return res2.data.attributes;
		// }

		return []
		// const res = await get(`/hape/equipped/drops`,{
		//     hape_id: Id,
		// })
		// if (res.code === 200) {
		//     return res.data.drops
		// }
		// const res2 = await get(`hape/original/equipped/drops`,{
		//     hape_id: Id,
		// })
		// if (res2.code === 200) {
		//     return res2.data.drops
		// }
		// return []
	}

	const getAutumnBoxDrops = async () => {
		const res = await get(`/autumn-ops/list`)
		if (res.code === 200) {
			return res.data.drops
		}
		return []
	}

	const getUserHapes = async (
		wallet_address: string = null,
		contract_address: string = null,
	) => {
		console.log("getUserHapes wallet_address", wallet_address)
		const res = await get(`/users/hapes`, {
			page: 1,
			size: 1000,
			wallet_address: wallet_address,
			contract_address: contract_address,
		})
		if (res.code === 200) {
			return res.data
		}
		return null
	}

	const getUserApparels = async (
		wallet_address: string = null,
		contract_address: string = null,
	) => {
		const res = await get(`/users/accessories`, {
			wallet_address: wallet_address,
		})
		if (res.code === 200) {
			let drops = res.data.drops
			let temp = drops.filter(
				(drop) =>
					drop.token_id &&
					Number(drop.token_id) > 0 &&
					drop.is_nft &&
					drop.contract_address.toLowerCase() ===
						CONTRACT_ADDRESS.HapeAccessory_Contract_address.toLowerCase() &&
					!drop.is_equipped,
			)
			const seen = new Set()
			temp = temp.filter((drop) => {
				if (seen.has(drop.token_id)) return false
				seen.add(drop.token_id)
				return true
			})
			return temp
		}
		return []
	}

	const getUserPoints = async () => {
		const res = await get(`/users/points/total`)
		if (res?.code !== 200 || res?.data == null) {
			return 0
		}
		const tp = res.data.total_points
		if (typeof tp === "number" && Number.isFinite(tp)) {
			return tp
		}
		const parsed = parseFloat(String(tp ?? "0"))
		return Number.isFinite(parsed) ? parsed : 0
	}

	const getHapeMetadata = async (tokenId: string, contract_address: string) => {
		const res = await app_get(`/hape/metadata/${contract_address}/${tokenId}`)
		console.log("getHapeMetadata res---->", res)
		return res
		// if (res.status === 200) {
		//     return res
		// }
		// return null
	}

	const getTraitMetadata = async (
		tokenId: string,
		contract_address: string,
	) => {
		const res = await app_get(`/drop/metadata/${contract_address}/${tokenId}`)
		console.log("getTraitMetadata res---->", res)
		return res
		// if (res.status === 200) {
		//     return res
		// }
		// return null
	}

	const getHapeBackground = async (hape_id: string, attributes: any[]) => {
		const res = await post(`/hape/generator/equipped/image`, {
			hape_id: hape_id,
			attributes: attributes,
			fmt: "png",
			isoloate: true,
		})
		if (res.code === 200) {
			return res.data
		}
		return null
	}

	const getHapeImageNoBackground = async (
		hape_id: string,
		hape_uuid: string,
		attributes: any[],
		is_only_background: boolean = false,
	) => {
		let data = {
			hape_id: hape_id,
			attributes: attributes,
			fmt: "png",
			include_background: false,
			hape_uuid: hape_uuid,
			isolate: false,
		}
		if (is_only_background) {
			data.include_background = true
			data.isolate = true
		}
		const res = await post(`/hape/generator/equipped/image`, data)
		if (res.code === 200) {
			return res.data
		}
		return null
	}

	const getProofData = async (tokenIds: number[]) => {
		console.log("getProofData tokenIds---->", tokenIds)
		try {
			const res = await get("/drops/proof", { token_ids: tokenIds })
			if (res?.code === 200) {
				return res.data ?? []
			} else {
				return []
			}
		} catch (e) {
			console.error("getProofData error:", e)
			return []
		}
	}

	const updateMigrationRecords = async (
		token_ids: number[],
		contract_address: string,
		type: string,
		wallet_address: string,
		hash: string,
	) => {
		const res = await post(`/users/migration/records/create`, {
			token_ids: token_ids,
			contract_address: contract_address,
			type: type, // hape, drop
			wallet_address: wallet_address,
			status: 0, // 0: pending, 1: success, 2: failed
			transaction_hash: hash,
		})
		return res
	}

	const getMigrationRecords = async (
		token_ids: any[],
		type: string,
		wallet_address: string = null,
		contract_address: string = null,
	) => {
		const res = await post(`/users/migration/records/list`, {
			token_ids: token_ids,
			type: type,
			wallet_address: wallet_address,
			contract_address: contract_address,
		})
		if (res.code === 200) {
			return res.data
		}
		return []
	}
	return {
		get,
		post,
		registerVote,
		getOrders,
		getProductList,
		fetchBanner,
		getCategoriesForFilters,
		getLiveCollections,
		getColorsForFilters,
		getWalletAddressList,
		addCart,
		getCart,
		removeFromCart,
		getProduct,
		getWalletList,
		unbindWallet,
		checkWallet,
		bindWallet,
		getInventoryList,
		livePriceFunc,
		getSignature,
		updateOrder,
		getBoxList,
		openBox,
		getOpenBoxNonce,
		getBoxDrops,
		getUserBoxes,
		getSetBoxEligibility,
		claimSetBoxReward,
		getShareInfo,
		getVoteInfo,
		vote,
		getEquippedTraits,
		getAutumnBoxDrops,
		getUserHapes,
		getUserApparels,
		getUserPoints,
		getHapeMetadata,
		getTraitMetadata,
		app_get,
		getHapeBackground,
		getHapeImageNoBackground,
		getProofData,
		updateMigrationRecords,
		getMigrationRecords,
	}
}

export default useRequest
